<div class="w-full py-3 px-4">
  <div class="sm:flex items-center justify-between mb-4">
    <div class="flex items-center justify-start gap-1 lg:gap-2 mb-3 lg:mb-0"><svg viewBox="0 0 24 24" fill="none"
        xmlns="http://www.w3.org/2000/svg" class="size-6">
        <mask id="mask0_848_1764" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"
          style="mask-type: alpha;">
          <rect width="24" height="24" fill="#C19725"></rect>
        </mask>
        <g mask="url(#mask0_848_1764)">
          <path d="M16 22L6 12L16 2L17.775 3.775L9.55 12L17.775 20.225L16 22Z" fill="#C19725"></path>
        </g>
      </svg><img src="/assets/images/stock/order.png" alt="Report" class="size-6 sm:size-8 lg:size-10"><span
        class="font-semibold text-sm sm:text-base lg:text-xl text-444">Order Creation</span>
    </div>
    <a routerLink="/product-creation"
      class="block cursor-pointer px-3 py-1.5 text-xs sm:text-sm lg:text-base font-semibold text-white bg-c19725 border-2 border-c19725 hover:bg-[#fdffc6] hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center dark:bg-c19725 dark:hover:bg-[#fdffc6]">
      Add Product
    </a>
  </div>

  <div class="flex flex-wrap lg:flex-nowrap justify-between items-center gap-1 sm:gap-2">
    <div class="flex items-center justify-center md:justify-start gap-1 sm:gap-2">
      <div class="relative flex items-center gap-1 sm:gap-2">
        <label for="rowFilter" class="text-xs sm:text-sm font-medium text-gray-800 whitespace-nowrap">
          Rows :
        </label>
        <select id="rowFilter" [(ngModel)]="visibleRowCount" (change)="updateVisibleRows()"
          class="border border-dcdcdc rounded-[5px] p-1 text-xs sm:text-sm appearance-none !bg-none pr-6 focus:outline-none focus:ring-0 focus:border-c19725">
          <option *ngFor="let count of [5, 10, 20, 30, 40, 50, 100]" [value]="count">
            {{ count }}
          </option>
        </select>
        <div class="absolute inset-y-0 right-1.5 flex items-center pointer-events-none">
          <svg width="10" height="5" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.00004 7.00016L0.333374 0.333496H13.6667L7.00004 7.00016Z" fill="#C19725" />
          </svg>
        </div>
      </div>

      <div class="flex items-center gap-1 sm:gap-2">
        <label for="globalSearch" class="text-xs sm:text-sm font-medium text-gray-800 whitespace-nowrap">
          Search :
        </label>
        <input id="globalSearch" type="text" [(ngModel)]="globalSearchText" (ngModelChange)="filterTable()"
          placeholder="Search all columns..."
          class="border border-dcdcdc rounded-[5px] px-3 py-1 text-xs sm:text-sm w-32 lg:w-64 focus:outline-none focus:ring-0 focus:border-c19725"
          autocomplete="off" />
      </div>
    </div>

    <div class="flex items-center flex-wrap lg:flex-nowrap justify-center md:justify-end gap-2">
      <button
        class="text-[#F20707] border-1 border-[#F20707] bg-[#fff6f3] font-medium text-xs md:text-sm px-1 md:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        (click)="downloadPDF()">
        Download PDF
      </button>
      <button
        class="text-[#029921] border-1 border-[#029921] bg-[#e6ffe6] font-medium text-xs md:text-sm px-1 md:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        (click)="downloadExcel()">
        Download Excel
      </button>
      <button
        class="text-[#0720EC] border-1 border-[#0720EC] bg-[#E8E6FF] font-medium text-xs md:text-sm px-1 md:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        (click)="downloadJSONAll()">
        Download All JSON
      </button>
      <button
        class="text-[#00ad94] border-1 border-[#00ad94] bg-[#e5fffb] font-medium text-xs md:text-sm px-1 md:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        (click)="downloadCSV()">
        Download CSV
      </button>

      <div class="relative inline-block text-left">
        <button (click)="toggleDropdown()"
          class="text-[#B92185] border-1 border-[#B92185] bg-[#FFE1F5] font-medium text-xs md:text-sm px-1 md:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition">
          Column Visibility
        </button>

        <div *ngIf="showDropdown" class="absolute z-50 mt-2 p-4 bg-white border rounded shadow -left-24 w-64">
          <p class="font-semibold mb-2">Select Columns to Show:</p>

          <label *ngFor="let field of selectedFields" class="block text-sm mb-1">
            <input type="checkbox" [(ngModel)]="field.selected" (change)="onFieldToggle(field)" autocomplete="off" />
            {{ field.label }}
          </label>

          <div class="mt-3 flex flex-col gap-2">
            <button (click)="selectAllFields()" class="text-sm text-blue-600 hover:underline text-left">
              Select All
            </button>
            <button (click)="deselectAllFields()" class="text-sm text-red-800 hover:underline text-left">
              Deselect All
            </button>
            <button (click)="restoreColumnSelection()" class="text-sm text-gray-600 hover:underline text-left">
              Restore Columns
            </button>

            <button (click)="showDropdown=false"
              class="mt-2 bg-c19725 text-white text-xs md:text-sm px-1 md:px-4 py-2 rounded-[5px] transition">
              Apply
            </button>
          </div>
        </div>
      </div>
      <button (click)="printTable()"
        class="text-[#5606b6] border-1 border-[#5606b6] bg-[#ecddff] font-medium text-sm px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition">
        Print
      </button>
    </div>
  </div>

  <div class="w-full mt-3 mb-4 lg:mb-0">
    <div
      class="w-full bg-[#FFF5F2] p-3 rounded-md grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 2xl:grid-cols-8 gap-2 space-y-0.5">

      <div class="col-span-1">
        <div class="relative">
          <input type="text" id="" formControlName=""
            class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none  dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-c19725 peer"
            placeholder=" " autocomplete="off" />
          <label for=""
            class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white  px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Product
            Code</label>
        </div>
      </div>

      <div class="col-span-1">
        <div class="relative">
          <input type="text" id="" formControlName=""
            class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none  dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-c19725 peer"
            placeholder=" " autocomplete="off" />
          <label for=""
            class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white  px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Product
            Name</label>
        </div>
      </div>

      <div class="col-span-1">
        <div
          class="group relative flex items-center justify-start py-1 px-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc">
          <img src="/assets/images/firm/firm-img.png" alt="Report" class="size-7"><label
            class="ms-1 text-sm lg:text-sm text-[#898989] truncate">image.png</label>
          <div
            class="absolute left-10 -top-2.5 z-50 opacity-0 scale-90 transition-all duration-300 ease-in-out pointer-events-none group-hover:opacity-100 group-hover:scale-100">
            <img src="/assets/images/firm/firm-img.png" alt="Zoom"
              class="size-20 border border-gray-300 shadow-lg bg-white rounded" />
          </div>
        </div>
      </div>

      <div class="col-span-1">
        <div class="relative">
          <input type="text" id="" formControlName=""
            class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none  dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-c19725 peer"
            placeholder=" " autocomplete="off" />
          <label for=""
            class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white  px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Qty</label>
        </div>
      </div>

      <div class="col-span-1">
        <div class="relative">
          <input type="text" id="" formControlName=""
            class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none  dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-c19725 peer"
            placeholder=" " autocomplete="off" />
          <label for=""
            class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white  px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Assignee</label>
        </div>
      </div>

      <div class="col-span-1">
        <div class="h-full flex items-center justify-end gap-3">
          <p class="flex items-center gap-1 text-sm lg:text-lg text-[#0BB60B] font-medium">
            <svg class="cursor-pointer size-6 lg:size-10" fill="#0BB60B" viewBox="0 0 56.00 56.00"
              xmlns="http://www.w3.org/2000/svg" stroke="#0BB60B">
              <g id="SVGRepo_bgCarrier" stroke-width="0" transform="translate(9.52,9.52), scale(0.66)">
                <rect x="0" y="0" width="56.00" height="56.00" rx="0" fill="#ffffff" strokewidth="0"></rect>
              </g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path
                  d="M 13.7851 49.5742 L 42.2382 49.5742 C 47.1366 49.5742 49.5743 47.1367 49.5743 42.3086 L 49.5743 13.6914 C 49.5743 8.8633 47.1366 6.4258 42.2382 6.4258 L 13.7851 6.4258 C 8.9101 6.4258 6.4257 8.8398 6.4257 13.6914 L 6.4257 42.3086 C 6.4257 47.1602 8.9101 49.5742 13.7851 49.5742 Z M 27.9882 39.6367 C 26.6523 39.6367 25.9492 38.6758 25.9492 37.3164 L 25.9492 30.0274 L 18.2617 30.0274 C 16.8788 30.0274 15.9179 29.3008 15.9179 28.0118 C 15.9179 26.6758 16.8320 25.9258 18.2617 25.9258 L 25.9492 25.9258 L 25.9492 18.1680 C 25.9492 16.8086 26.6523 15.8477 27.9882 15.8477 C 29.2773 15.8477 30.0742 16.7617 30.0742 18.1680 L 30.0742 25.9258 L 37.7851 25.9258 C 39.2148 25.9258 40.1054 26.6758 40.1054 28.0118 C 40.1054 29.3008 39.1679 30.0274 37.7851 30.0274 L 30.0742 30.0274 L 30.0742 37.3164 C 30.0742 38.7227 29.2773 39.6367 27.9882 39.6367 Z">
                </path>
              </g>
            </svg> Add
          </p>

          <p class="flex items-center gap-1 text-sm lg:text-lg text-[#BB0000] font-medium">
            <svg class="cursor-pointer size-5 lg:size-8" viewBox="0 0 30 31" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <rect y="0.5" width="30" height="30" rx="5" fill="#BB0000" />
              <path
                d="M7.06189 17C7.02104 16.6724 7 16.3387 7 16C7 11.5817 10.5817 8 15 8C17.5006 8 19.7332 9.14727 21.2002 10.9442M21.2002 10.9442V8M21.2002 10.9442V10.9999L18.2002 11M22.9381 15C22.979 15.3276 23 15.6613 23 16C23 20.4183 19.4183 24 15 24C12.6106 24 10.4659 22.9525 9 21.2916M9 21.2916V21H12M9 21.2916V24"
                stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg> Clear
          </p>
        </div>
      </div>


    </div>
  </div>


  <div class="overflow-x-auto whitespace-nowrap hide-scrollbar">
    <table
      class="w-full table border border-b-0 border-[#D9D9D9] border-separate border-spacing-0 bg-white overflow-hidden mt-5">
      <thead class="bg-[#F2F2F2] text-444 text-xs sm:text-sm lg:text-base">
        <tr>
          <!-- <th
            class="p-2 font-medium text-center border-r border-444 last:border-r-0"
          >
            No.
          </th> -->
          <th *ngFor="let field of selectedFields" [hidden]="!field.selected"
            class="p-2 font-medium text-left border-r border-444 last:border-r-0">
            <div class="flex flex-col gap-1 w-32">
              <input type="text" [(ngModel)]="searchValues[field.key]" (click)="$event.stopPropagation()"
                (ngModelChange)="filterTable()" [attr.placeholder]="'Search ' + field.label"
                class="border border-dcdcdc p-1 rounded text-xs w-full" autocomplete="off" />

              <div class="text-xs font-medium text-gray-700 flex items-center gap-1 cursor-pointer select-none"
                (click)="sortBy(field.key)">
                {{ field.label }}
                <svg *ngIf="sortKey === field.key" class="w-3 h-3" viewBox="0 0 24 24">
                  <path *ngIf="sortDirection === 'asc'" d="M12 8l6 6H6z" fill="currentColor" />
                  <path *ngIf="sortDirection === 'desc'" d="M12 16l-6-6h12z" fill="currentColor" />
                </svg>
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody class="text-xs sm:text-sm lg:text-base">
        <ng-container *ngIf="paginatedDesignProductList.length > 0; else noData">
          <ng-container *ngIf="firstValidItem as item">
            <tr>
              <ng-container *ngFor="let field of selectedFields">
                <td *ngIf="field.selected" class="p-2 border-r border-b border-[#D9D9D9]">
                  <ng-container [ngSwitch]="field.key">

                    <ng-container *ngSwitchCase="'image'">
                      <div class="image-container">
                        <img
                          [src]="item['product_image'] || item['product_image_2'] || item['product_image_3'] || item['product_image_4'] || item['product_image_5']"
                          alt="Product Image" class="product-image w-12 h-12 object-contain" />
                      </div>
                    </ng-container>

                    <ng-container *ngSwitchCase="'metal_data'">
                      <div *ngIf="item?.metal_data?.length; else noMetalData">
                        <table class="w-full text-xs border-collapse">
                          <thead>
                            <tr class="bg-gray-100">
                              <th class="py-1 px-2 border">Product Code</th>
                              <th class="py-1 px-2 border">Product Name</th>
                              <th class="py-1 px-2 border">Per Piece WT</th>
                              <th class="py-1 px-2 border">Total Silver part wt</th>
                              <th class="py-1 px-2 border">Metal Qty</th>
                              <th class="py-1 px-2 border">Product Qty</th>
                              <th class="py-1 px-2 border">Total Silver Metal Price</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let metal of item.metal_data">
                              <td class="py-1 px-2 border">{{ metal.code }}</td>
                              <td class="py-1 px-2 border">{{ metal.artical_name }}</td>
                              <td class="py-1 px-2 border">{{ metal.per_piece_weight }}</td>
                              <td class="py-1 px-2 border">{{ metal.total_weight }}</td>
                              <td class="py-1 px-2 border">{{ metal.quantity }}</td>
                              <td class="py-1 px-2 border">
                                {{ (item.new_qty || 0) * (metal.quantity || 0) }}
                              </td>
                              <td class="py-1 px-2 border">
                                {{
                                (metal.quantity || 0) *
                                ((item.new_qty || 0) * (metal.quantity || 0)) *
                                (metal.per_piece_weight || 0)
                                | number:'1.2-2' }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <ng-template #noMetalData>
                        <span class="text-gray-500">N/A</span>
                      </ng-template>
                    </ng-container>

                    <ng-container *ngSwitchCase="'stone_data'">
                      <div *ngIf="item?.stone_data?.length; else noStoneData">
                        <table class="w-full text-xs border-collapse">
                          <thead>
                            <tr class="bg-gray-100">
                              <th class="py-1 px-2 border">Product Code</th>
                              <th class="py-1 px-2 border">Product Name</th>
                              <th class="py-1 px-2 border">Stone Qty</th>
                              <th class="py-1 px-2 border">Product Qty</th>
                              <th class="py-1 px-2 border">Stone Price</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let stone of item.stone_data">
                              <td class="py-1 px-2 border">{{ stone.code }}</td>
                              <td class="py-1 px-2 border">{{ stone.stone_name }}</td>
                              <td class="py-1 px-2 border">{{ stone.quantity }}</td>
                              <td class="py-1 px-2 border">{{ item.new_qty || 0 }}</td>
                              <td class="py-1 px-2 border">
                                {{
                                (stone.quantity || 0) *
                                (item.new_qty || 0)
                                | number:'1.2-2' }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <ng-template #noStoneData>
                        <span class="text-gray-500">N/A</span>
                      </ng-template>
                    </ng-container>

                    <ng-container *ngSwitchCase="'packaging_data'">
                      <div *ngIf="item?.packaging_data?.length; else noPackagingData">
                        <table class="w-full text-xs border-collapse">
                          <thead>
                            <tr class="bg-gray-100">
                              <th class="py-1 px-2 border">Product Code</th>
                              <th class="py-1 px-2 border">Product Name</th>
                              <th class="py-1 px-2 border">Qty</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let packaging of item.packaging_data">
                              <td class="py-1 px-2 border">{{ packaging.product_code }}</td>
                              <td class="py-1 px-2 border">{{ packaging.material_name }}</td>
                              <td class="py-1 px-2 border">{{ packaging.quantity }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <ng-template #noPackagingData>
                        <span class="text-gray-500">N/A</span>
                      </ng-template>
                    </ng-container>

                    <ng-container *ngSwitchCase="'total_price'">
                      {{ item['latest_price_info']?.['purchase_price'] || 'N/A' }}
                    </ng-container>

                    <ng-container *ngSwitchCase="'total_thread'">
                      {{ item['latest_price_info']?.['thread_price'] || 'N/A' }}
                    </ng-container>

                    <ng-container *ngSwitchCase="'unique_code_sku'">
                      <select [(ngModel)]="selectedProductCode" (change)="filterByProductCode()"
                        class="w-full text-xs border px-1 py-0.5 border-gray-300 rounded">
                        <option value="" disabled>Select Product Code</option>
                        <option *ngFor="let product of designProductList" [value]="product['unique_code_sku']">
                          {{ product['unique_code_sku'] }} - {{ product['product_name'] }}
                        </option>
                      </select>
                    </ng-container>

                    <ng-container *ngSwitchDefault>
                      <ng-container *ngIf="field.input; else plainText">
                        <input type="number" [(ngModel)]="item[field.key]"
                          class="w-full no-spinner border text-xs px-1 py-0.5 rounded border-gray-300"
                          placeholder="{{ field.label }}" />
                      </ng-container>
                      <ng-template #plainText>
                        {{ item[field.key] ?? 'N/A' }}
                      </ng-template>
                    </ng-container>

                  </ng-container>
                </td>
              </ng-container>
            </tr>
          </ng-container>
        </ng-container>

        <!-- No Data -->
        <ng-template #noData>
          <tr>
            <td [attr.colspan]="selectedFields.length" class="text-center py-4">
              No products found.
            </td>
          </tr>
        </ng-template>
      </tbody>

    </table>
  </div>

  <div class="flex items-center justify-end border-t border-gray-200 bg-white py-3">
    <div class="flex sm:flex-1 sm:items-center sm:justify-end">
      <div>
        <nav class="isolate inline-flex gap-2 -space-x-px rounded-md shadow-xs" aria-label="Pagination">
          <button (click)="goToPreviousPage()" [disabled]="currentPage === 1"
            class="relative inline-flex items-center justify-center w-6 h-6 md:w-7 md:h-7 rounded-[5px] text-c19725 ring-1 ring-c19725 ring-inset hover:bg-[#f6f1cb] focus:z-20 focus:outline-offset-0">
            <span class="sr-only">Previous</span>
            <svg class="size-6" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
              <path fill-rule="evenodd"
                d="M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z"
                clip-rule="evenodd" />
            </svg>
          </button>
          <ng-container *ngFor="let page of pageNumbers">
            <button (click)="goToPage(page)" [class.bg-c19725]="currentPage === page"
              [class.text-white]="currentPage === page"
              class="relative z-10 inline-flex items-center justify-center w-6 h-6 md:w-7 md:h-7 rounded-[5px] text-sm font-normal text-c19725 ring-1 ring-c19725 ring-inset focus:z-20 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-c19725">
              {{ page }}
            </button>
          </ng-container>

          <button (click)="goToNextPage()" [disabled]="currentPage === totalPages"
            class="relative inline-flex items-center justify-center w-6 h-6 md:w-7 md:h-7 rounded-[5px] text-c19725 ring-1 ring-c19725 ring-inset hover:bg-[#f6f1cb] focus:z-20 focus:outline-offset-0">
            <span class="sr-only">Next</span>
            <svg class="size-6" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
              <path fill-rule="evenodd"
                d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
                clip-rule="evenodd" />
            </svg>
          </button>
        </nav>
      </div>
    </div>
  </div>

  <div class="flex items-start justify-between gap-2">
    <div class="overflow-x-auto whitespace-nowrap hide-scrollbar">
      <table
        class="w-full xl:w-1/2 table border border-b-0 border-[#D9D9D9] border-separate border-spacing-0 bg-white overflow-hidden mt-5">
        <thead class="bg-[#F2F2F2] text-444 text-xs">
          <tr>
            <th class="p-2 font-medium text-center border-r border-444 last:border-r-0">
              Sr. No.
            </th>
            <th *ngFor="let field of selectedFields" [hidden]="!field.selected"
              class="p-2 font-medium text-left border-r border-444 last:border-r-0">
              <div class="flex flex-col gap-1 w-32">
                <input type="text" [(ngModel)]="searchValues[field.key]" (click)="$event.stopPropagation()"
                  (ngModelChange)="filterTable()" [attr.placeholder]="'Search ' + field.label"
                  class="border border-dcdcdc p-1 rounded text-xs w-full" autocomplete="off" />

                <div class="text-xs font-medium text-gray-700 flex items-center gap-1 cursor-pointer select-none"
                  (click)="sortBy(field.key)">
                  {{ field.label }}
                  <svg *ngIf="sortKey === field.key" class="w-3 h-3" viewBox="0 0 24 24">
                    <path *ngIf="sortDirection === 'asc'" d="M12 8l6 6H6z" fill="currentColor" />
                    <path *ngIf="sortDirection === 'desc'" d="M12 16l-6-6h12z" fill="currentColor" />
                  </svg>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody class="text-xs sm:text-sm lg:text-base">
          <ng-container *ngIf="paginatedDesignProductList.length > 0; else noData">
            <ng-container *ngIf="firstValidItem as item">
              <tr>
                <ng-container *ngFor="let field of selectedFields">
                  <td *ngIf="field.selected" class="p-2 border-r border-b border-[#D9D9D9]">
                    <ng-container [ngSwitch]="field.key">

                      <ng-container *ngSwitchCase="'image'">
                        <div class="image-container">
                          <img
                            [src]="item['product_image'] || item['product_image_2'] || item['product_image_3'] || item['product_image_4'] || item['product_image_5']"
                            alt="Product Image" class="product-image w-12 h-12 object-contain" />
                        </div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'metal_data'">
                        <div *ngIf="item?.metal_data?.length; else noMetalData">
                          <table class="w-full text-xs border-collapse">
                            <thead>
                              <tr class="bg-gray-100">
                                <th class="py-1 px-2 border">Product Code</th>
                                <th class="py-1 px-2 border">Product Name</th>
                                <th class="py-1 px-2 border">Per Piece WT</th>
                                <th class="py-1 px-2 border">Total Silver part wt</th>
                                <th class="py-1 px-2 border">Metal Qty</th>
                                <th class="py-1 px-2 border">Product Qty</th>
                                <th class="py-1 px-2 border">Total Silver Metal Price</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let metal of item.metal_data">
                                <td class="py-1 px-2 border">{{ metal.code }}</td>
                                <td class="py-1 px-2 border">{{ metal.artical_name }}</td>
                                <td class="py-1 px-2 border">{{ metal.per_piece_weight }}</td>
                                <td class="py-1 px-2 border">{{ metal.total_weight }}</td>
                                <td class="py-1 px-2 border">{{ metal.quantity }}</td>
                                <td class="py-1 px-2 border">
                                  {{ (item.new_qty || 0) * (metal.quantity || 0) }}
                                </td>
                                <td class="py-1 px-2 border">
                                  {{
                                  (metal.quantity || 0) *
                                  ((item.new_qty || 0) * (metal.quantity || 0)) *
                                  (metal.per_piece_weight || 0)
                                  | number:'1.2-2' }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <ng-template #noMetalData>
                          <span class="text-gray-500">N/A</span>
                        </ng-template>
                      </ng-container>

                      <ng-container *ngSwitchCase="'stone_data'">
                        <div *ngIf="item?.stone_data?.length; else noStoneData">
                          <table class="w-full text-xs border-collapse">
                            <thead>
                              <tr class="bg-gray-100">
                                <th class="py-1 px-2 border">Product Code</th>
                                <th class="py-1 px-2 border">Product Name</th>
                                <th class="py-1 px-2 border">Stone Qty</th>
                                <th class="py-1 px-2 border">Product Qty</th>
                                <th class="py-1 px-2 border">Stone Price</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let stone of item.stone_data">
                                <td class="py-1 px-2 border">{{ stone.code }}</td>
                                <td class="py-1 px-2 border">{{ stone.stone_name }}</td>
                                <td class="py-1 px-2 border">{{ stone.quantity }}</td>
                                <td class="py-1 px-2 border">{{ item.new_qty || 0 }}</td>
                                <td class="py-1 px-2 border">
                                  {{
                                  (stone.quantity || 0) *
                                  (item.new_qty || 0)
                                  | number:'1.2-2' }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <ng-template #noStoneData>
                          <span class="text-gray-500">N/A</span>
                        </ng-template>
                      </ng-container>

                      <ng-container *ngSwitchCase="'packaging_data'">
                        <div *ngIf="item?.packaging_data?.length; else noPackagingData">
                          <table class="w-full text-xs border-collapse">
                            <thead>
                              <tr class="bg-gray-100">
                                <th class="py-1 px-2 border">Product Code</th>
                                <th class="py-1 px-2 border">Product Name</th>
                                <th class="py-1 px-2 border">Qty</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let packaging of item.packaging_data">
                                <td class="py-1 px-2 border">{{ packaging.product_code }}</td>
                                <td class="py-1 px-2 border">{{ packaging.material_name }}</td>
                                <td class="py-1 px-2 border">{{ packaging.quantity }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <ng-template #noPackagingData>
                          <span class="text-gray-500">N/A</span>
                        </ng-template>
                      </ng-container>

                      <ng-container *ngSwitchCase="'total_price'">
                        {{ item['latest_price_info']?.['purchase_price'] || 'N/A' }}
                      </ng-container>

                      <ng-container *ngSwitchCase="'total_thread'">
                        {{ item['latest_price_info']?.['thread_price'] || 'N/A' }}
                      </ng-container>

                      <ng-container *ngSwitchCase="'unique_code_sku'">
                        <select [(ngModel)]="selectedProductCode" (change)="filterByProductCode()"
                          class="w-full text-xs border px-1 py-0.5 border-gray-300 rounded">
                          <option value="" disabled>Select Product Code</option>
                          <option *ngFor="let product of designProductList" [value]="product['unique_code_sku']">
                            {{ product['unique_code_sku'] }} - {{ product['product_name'] }}
                          </option>
                        </select>
                      </ng-container>

                      <ng-container *ngSwitchDefault>
                        <ng-container *ngIf="field.input; else plainText">
                          <input type="number" [(ngModel)]="item[field.key]"
                            class="w-full no-spinner border text-xs px-1 py-0.5 rounded border-gray-300"
                            placeholder="{{ field.label }}" />
                        </ng-container>
                        <ng-template #plainText>
                          {{ item[field.key] ?? 'N/A' }}
                        </ng-template>
                      </ng-container>

                    </ng-container>
                  </td>
                </ng-container>
              </tr>
            </ng-container>
          </ng-container>

          <!-- No Data -->
          <ng-template #noData>
            <tr>
              <td [attr.colspan]="selectedFields.length" class="text-center py-4">
                No products found.
              </td>
            </tr>
          </ng-template>
        </tbody>

      </table>
    </div>

    <div class="overflow-x-auto whitespace-nowrap hide-scrollbar">
      <table
        class="w-full xl:w-1/2 table border border-b-0 border-[#D9D9D9] border-separate border-spacing-0 bg-white overflow-hidden mt-5">
        <thead class="bg-[#F2F2F2] text-444 text-xs">
          <tr>
            <th class="p-2 font-medium text-center border-r border-444 last:border-r-0">
              Sr. No.
            </th>
            <th *ngFor="let field of selectedFields" [hidden]="!field.selected"
              class="p-2 font-medium text-left border-r border-444 last:border-r-0">
              <div class="flex flex-col gap-1 w-32">
                <input type="text" [(ngModel)]="searchValues[field.key]" (click)="$event.stopPropagation()"
                  (ngModelChange)="filterTable()" [attr.placeholder]="'Search ' + field.label"
                  class="border border-dcdcdc p-1 rounded text-xs w-full" autocomplete="off" />

                <div class="text-xs font-medium text-gray-700 flex items-center gap-1 cursor-pointer select-none"
                  (click)="sortBy(field.key)">
                  {{ field.label }}
                  <svg *ngIf="sortKey === field.key" class="w-3 h-3" viewBox="0 0 24 24">
                    <path *ngIf="sortDirection === 'asc'" d="M12 8l6 6H6z" fill="currentColor" />
                    <path *ngIf="sortDirection === 'desc'" d="M12 16l-6-6h12z" fill="currentColor" />
                  </svg>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody class="text-xs sm:text-sm lg:text-base">
          <ng-container *ngIf="paginatedDesignProductList.length > 0; else noData">
            <ng-container *ngIf="firstValidItem as item">
              <tr>
                <ng-container *ngFor="let field of selectedFields">
                  <td *ngIf="field.selected" class="p-2 border-r border-b border-[#D9D9D9]">
                    <ng-container [ngSwitch]="field.key">

                      <ng-container *ngSwitchCase="'image'">
                        <div class="image-container">
                          <img
                            [src]="item['product_image'] || item['product_image_2'] || item['product_image_3'] || item['product_image_4'] || item['product_image_5']"
                            alt="Product Image" class="product-image w-12 h-12 object-contain" />
                        </div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'metal_data'">
                        <div *ngIf="item?.metal_data?.length; else noMetalData">
                          <table class="w-full text-xs border-collapse">
                            <thead>
                              <tr class="bg-gray-100">
                                <th class="py-1 px-2 border">Product Code</th>
                                <th class="py-1 px-2 border">Product Name</th>
                                <th class="py-1 px-2 border">Per Piece WT</th>
                                <th class="py-1 px-2 border">Total Silver part wt</th>
                                <th class="py-1 px-2 border">Metal Qty</th>
                                <th class="py-1 px-2 border">Product Qty</th>
                                <th class="py-1 px-2 border">Total Silver Metal Price</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let metal of item.metal_data">
                                <td class="py-1 px-2 border">{{ metal.code }}</td>
                                <td class="py-1 px-2 border">{{ metal.artical_name }}</td>
                                <td class="py-1 px-2 border">{{ metal.per_piece_weight }}</td>
                                <td class="py-1 px-2 border">{{ metal.total_weight }}</td>
                                <td class="py-1 px-2 border">{{ metal.quantity }}</td>
                                <td class="py-1 px-2 border">
                                  {{ (item.new_qty || 0) * (metal.quantity || 0) }}
                                </td>
                                <td class="py-1 px-2 border">
                                  {{
                                  (metal.quantity || 0) *
                                  ((item.new_qty || 0) * (metal.quantity || 0)) *
                                  (metal.per_piece_weight || 0)
                                  | number:'1.2-2' }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <ng-template #noMetalData>
                          <span class="text-gray-500">N/A</span>
                        </ng-template>
                      </ng-container>

                      <ng-container *ngSwitchCase="'stone_data'">
                        <div *ngIf="item?.stone_data?.length; else noStoneData">
                          <table class="w-full text-xs border-collapse">
                            <thead>
                              <tr class="bg-gray-100">
                                <th class="py-1 px-2 border">Product Code</th>
                                <th class="py-1 px-2 border">Product Name</th>
                                <th class="py-1 px-2 border">Stone Qty</th>
                                <th class="py-1 px-2 border">Product Qty</th>
                                <th class="py-1 px-2 border">Stone Price</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let stone of item.stone_data">
                                <td class="py-1 px-2 border">{{ stone.code }}</td>
                                <td class="py-1 px-2 border">{{ stone.stone_name }}</td>
                                <td class="py-1 px-2 border">{{ stone.quantity }}</td>
                                <td class="py-1 px-2 border">{{ item.new_qty || 0 }}</td>
                                <td class="py-1 px-2 border">
                                  {{
                                  (stone.quantity || 0) *
                                  (item.new_qty || 0)
                                  | number:'1.2-2' }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <ng-template #noStoneData>
                          <span class="text-gray-500">N/A</span>
                        </ng-template>
                      </ng-container>

                      <ng-container *ngSwitchCase="'packaging_data'">
                        <div *ngIf="item?.packaging_data?.length; else noPackagingData">
                          <table class="w-full text-xs border-collapse">
                            <thead>
                              <tr class="bg-gray-100">
                                <th class="py-1 px-2 border">Product Code</th>
                                <th class="py-1 px-2 border">Product Name</th>
                                <th class="py-1 px-2 border">Qty</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let packaging of item.packaging_data">
                                <td class="py-1 px-2 border">{{ packaging.product_code }}</td>
                                <td class="py-1 px-2 border">{{ packaging.material_name }}</td>
                                <td class="py-1 px-2 border">{{ packaging.quantity }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <ng-template #noPackagingData>
                          <span class="text-gray-500">N/A</span>
                        </ng-template>
                      </ng-container>

                      <ng-container *ngSwitchCase="'total_price'">
                        {{ item['latest_price_info']?.['purchase_price'] || 'N/A' }}
                      </ng-container>

                      <ng-container *ngSwitchCase="'total_thread'">
                        {{ item['latest_price_info']?.['thread_price'] || 'N/A' }}
                      </ng-container>

                      <ng-container *ngSwitchCase="'unique_code_sku'">
                        <select [(ngModel)]="selectedProductCode" (change)="filterByProductCode()"
                          class="w-full text-xs border px-1 py-0.5 border-gray-300 rounded">
                          <option value="" disabled>Select Product Code</option>
                          <option *ngFor="let product of designProductList" [value]="product['unique_code_sku']">
                            {{ product['unique_code_sku'] }} - {{ product['product_name'] }}
                          </option>
                        </select>
                      </ng-container>

                      <ng-container *ngSwitchDefault>
                        <ng-container *ngIf="field.input; else plainText">
                          <input type="number" [(ngModel)]="item[field.key]"
                            class="w-full no-spinner border text-xs px-1 py-0.5 rounded border-gray-300"
                            placeholder="{{ field.label }}" />
                        </ng-container>
                        <ng-template #plainText>
                          {{ item[field.key] ?? 'N/A' }}
                        </ng-template>
                      </ng-container>

                    </ng-container>
                  </td>
                </ng-container>
              </tr>
            </ng-container>
          </ng-container>

          <!-- No Data -->
          <ng-template #noData>
            <tr>
              <td [attr.colspan]="selectedFields.length" class="text-center py-4">
                No products found.
              </td>
            </tr>
          </ng-template>
        </tbody>

      </table>
    </div>
  </div>

</div>
